import type { EnvironmentConfig } from '@/types';

// Runtime config from public/config.js (can be changed on server without rebuild)
declare global {
  interface Window {
    __APP_CONFIG__?: {
      apiBaseUrl?: string;
      apiVersion?: string;
      cmsCacheDuration?: number;
    };
  }
}

const runtimeConfig = window.__APP_CONFIG__ || {};

/**
 * Application Configuration
 * Priority: Runtime config (config.js) > Build-time env vars > Defaults
 */
export const config: EnvironmentConfig = {
  apiBaseUrl: runtimeConfig.apiBaseUrl || import.meta.env.VITE_API_BASE_URL,
  apiVersion: runtimeConfig.apiVersion || import.meta.env.VITE_API_VERSION || 'v1',
  cmsCacheDuration: runtimeConfig.cmsCacheDuration || parseInt(import.meta.env.VITE_CMS_CACHE_DURATION || '300000', 10),
};

/**
 * Get full API URL
 */
export const getApiUrl = (path: string): string => {
  const basePath = `/api/${config.apiVersion}`;
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${config.apiBaseUrl}${basePath}${cleanPath}`;
};
